import { render, staticRenderFns } from "./sellerProducts.vue?vue&type=template&id=e1128afe"
import script from "./sellerProducts.vue?vue&type=script&lang=js"
export * from "./sellerProducts.vue?vue&type=script&lang=js"
import style0 from "./sellerProducts.vue?vue&type=style&index=0&id=e1128afe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports